import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/hooks/useAuth';
import { firstPermittedAdminPath } from '../shared/navConfig';
import './AdminPanel.css';

// Wraps every /admin/* sub-route; provides the content card and the page-title
// is rendered by the global TopBar.
export function AdminLayout() {
  return (
    <div className="admin-content">
      <Outlet />
    </div>
  );
}

// Index route for /admin: send the user to the first sub-section they may access.
export function AdminIndexRedirect() {
  const { userRole } = useAuth();
  return <Navigate to={firstPermittedAdminPath(userRole)} replace />;
}
